export class CopyLink extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', () => this.handleClick())
  }
  handleClick() {
    const copied = this.querySelector('.copied-message')
    copied.removeAttribute('hidden')

    const url = window.location.href
    // eslint-disable-next-line
    window.navigator.clipboard.writeText(url)

    setTimeout(() => copied.setAttribute('hidden', ''), 2000)
  }
}
